
//Todo : Need form with title and bg
export default function SecondHeroBanner(props: { data: any }) {
    return <></>
};